import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

const agreementsSlice = createSlice({
  name: 'agreements',

  initialState: {
    askUserToAgreeToAgreements: false,
    agreements: [],
  },

  reducers: {
    setAgreements(state, action) {
      const { agreements } = action.payload;

      if (agreements?.length > 0) {
        state.askUserToAgreeToAgreements = true;
        state.agreements = agreements;
      } else {
        state.askUserToAgreeToAgreements = false;
      }
    },

    skipAgreements(state) {
      state.askUserToAgreeToAgreements = false;
    },
  },
});

export const { setAgreements, skipAgreements } = agreementsSlice.actions;

export const selectAgreements = (state) => state.agreements;
export const selectAllAgreements = createSelector(
  selectAgreements,
  (agreements) => agreements.agreements
);

export default agreementsSlice.reducer;
